import { apiFetch } from './http';

export async function getUsers(options = {}) {
  const endpoint = options.directory ? '/users/directory' : '/users';
  const { users } = await apiFetch(endpoint);
  return users;
}

export async function createUser(payload) {
  await apiFetch('/users', { method: 'POST', body: payload });
}

export async function updateUserApi(id, payload) {
  await apiFetch(`/users/${id}`, { method: 'PUT', body: payload });
}

export async function deactivateUserApi(id) {
  await apiFetch(`/users/${id}`, { method: 'DELETE' });
}

export async function getAccessTree() {
  const { areas } = await apiFetch('/api/areas/tree');
  return Array.isArray(areas) ? areas : [];
}

export async function getUserAccess(userId) {
  const { subareaIds } = await apiFetch(`/users/${userId}/access`);
  return Array.isArray(subareaIds) ? subareaIds : [];
}

export async function getAllowedAreas() {
  const { areas } = await apiFetch('/api/areas/allowed');
  return Array.isArray(areas) ? areas : [];
}
